$('.blog-slider-js').each((key, slider) => {
    let dotsContainer = slider.closest('.blog').querySelector('.blog-slider-dots');
    $(slider).owlCarousel({
        items: 1,
        dots: true,
        nav: false,
        navText: ['&larr;', '&rarr;'],
        dotsContainer,

        responsive: {
            650: {
                items: 2,
            },
            993: {
                items: 3,
            },
        },
    });
});